/**
 * Parse a comma-separated string or array into a string array.
 * Handles null, undefined, empty strings, and trims whitespace.
 *
 * @example
 * parseStringArray("a, b, c") // ["a", "b", "c"]
 * parseStringArray(["a", "b"]) // ["a", "b"]
 * parseStringArray(undefined) // []
 */
export function parseStringArray(value: string | string[] | null | undefined): string[] {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === 'string' && value.trim()) {
    return value.split(',').map((item) => item.trim()).filter(Boolean);
  }
  return [];
}

/**
 * Extract only the date portion from an ISO date string.
 * Useful for form inputs that need YYYY-MM-DD format.
 *
 * @example
 * extractDateOnly("2024-03-15T10:30:00Z") // "2024-03-15"
 * extractDateOnly(undefined) // ""
 */
export function extractDateOnly(isoString?: string | null): string {
  if (!isoString) return '';
  return isoString.split('T')[0] || '';
}

/**
 * Get today's date in YYYY-MM-DD format.
 * Useful for form default values and date comparisons.
 */
export function getTodayDate(): string {
  return new Date().toISOString().split('T')[0];
}
